var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('doc-menu',{on:{"init":_vm.initMenu}}),_c('el-main',[(_vm.content)?_c('article',[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.title))]),_c('div',{staticClass:"wangEditor-container"},[_c('div',{staticClass:"wangEditor-txt",domProps:{"innerHTML":_vm._s(_vm.content.content)}})])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }